import React from 'react';
import Head from 'next/head';
import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import { API, APIRoutes, BANNER_TARGETS } from '@utils/api';
import MainBanner from '@components/PageBanner';

import Offers from '@components/Offers';
import EmployersBanner from '@components/Internship/EmployersBanner';
import Assumptions from '@components/Internship/Assumptions';
import Schedule from '@components/Internship/Schedule';
import Partners from '@components/Internship/Partners';
import Declaration from '@components/Internship/Declaration';

function Internship({ banners, offers }) {
  const { t } = useTranslation('internship');

  return (
    <>
      <Head>
        <title>{t('page-title')}</title>
        <meta property="og:title" content="Holiday Interships" />
        <meta property="og:image" content={`${process.env.NEXT_PUBLIC_PORTAL_URL}/images/lodz.png`} />
        <meta property="og:image:secure_url" content={`${process.env.NEXT_PUBLIC_PORTAL_URL}/images/lodz.png`} />
        <meta property="og:image:width" content="200" />
        <meta property="og:image:height" content="279" />
        <meta property="og:description" content={`${process.env.NEXT_PUBLIC_PORTAL_URL}`} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${process.env.NEXT_PUBLIC_PORTAL_URL}/staze-wakacyjne`} />
      </Head>

      <MainBanner bannerItems={banners} />
      <Offers internships={offers.offers} offersCount={offers.meta.pagination.totalOffers} />
      <EmployersBanner />
      <Assumptions />
      <Schedule />
      <Declaration />
      <Partners />
    </>
  );
}

export async function getServerSideProps({ locale }: GetServerSidePropsContext) {
  try {
    const {
      data: { banners },
    } = await API.get(APIRoutes.banners([BANNER_TARGETS.INTERNSHIP]));
    const { data: offers } = await API.get(
      APIRoutes.offers({ pageSize: 6, promoted: true, practiceType: 'holiday_internship' })
    );

    return {
      props: {
        ...(await serverSideTranslations(locale, [
          'homepage',
          'navbar',
          'footer',
          'offers',
          'common',
          'internship',
          'newsletter',
        ])),
        banners,
        offers,
      },
    };
  } catch (error) {
    return { props: {} };
  }
}
export default Internship;
